import { SirenResponse } from '@awp/http';
import { Dictionary } from '@awp/core/utils';

export interface DataState {
  responses?: Dictionary<SirenResponse>;
}

export const INIT_DATA_STATE: DataState = {
  responses: {},
}